type StoredValueProgramWithDiscountingOffer = {
  id: string;
  discountingOffer: {
    id: string;
  };
};

export const findStoredValueProgramByDiscountingOfferId = <
  TProgram extends StoredValueProgramWithDiscountingOffer,
>(
  programs: TProgram[],
  offerId: string,
): TProgram | undefined => programs.find((program) => program.discountingOffer.id === offerId);
